import { CommonModule } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, forwardRef, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { Observable, Subject, Subscription, finalize } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { CommonSkeletonComponent } from 'src/app/skeleton/common-skeleton/common-skeleton.component';
import { CandidateCardComponent } from '../../cards/candidate-card/candidate-card.component';
import { CandidateDocumentsComponent } from '../candidate-documents/candidate-documents.component';
import { CandidateCardTableViewComponent } from '../candidate-card-table-view/candidate-card-table-view.component';
import { AppSettings } from 'src/app/services/AppSettings';
import { CandidateService } from 'src/app/services/CandidateService';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { GigsumoService } from 'src/app/services/gigsumoService';
import { JobService } from 'src/app/services/job.service';
import { JobModel } from 'src/app/services/jobModel';
import { SearchData } from 'src/app/services/searchData';
import Swal from 'sweetalert2';
import { PricePlanService } from '../../Price-subscritions/priceplanService';
import { ApiService } from './../../../services/api.service';
import { UtilService } from './../../../services/util.service';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';
// `app-new-job` is the host that mounts `app-job-applicants`, so the import
// is circular at TS level; `forwardRef` defers resolution until runtime.
// Required for the Invite-to-apply modal which re-uses NewJobComponent in
// `screenName='invite-job-listing'` mode (parity with talent-pool).
import { NewJobComponent } from 'src/app/page/homepage/layout-jobs/new-job/new-job.component';

import { ScrollIntentGate } from 'src/app/shared/scroll-intent-gate';
@Component({
  selector: 'app-job-applicants',
  standalone: true,
  imports: [CommonModule, FormsModule,
CommonSkeletonComponent, CandidateCardComponent, CandidateDocumentsComponent, CandidateCardTableViewComponent, InfiniteScrollModule,
    NG_ICON_DIRECTIVES,
    forwardRef(() => NewJobComponent),
  ],
  templateUrl: './job-applicants.component.html',
  styleUrls: ['./job-applicants.component.scss'],
  inputs: ['jobDetails']
})
export class JobApplicantsComponent implements OnInit, OnDestroy, OnChanges {
  // User-intent gate (src/app/shared/scroll-intent-gate.ts): after a page
  // lands, the next page needs a NEW physical input — a fast wheel flick's
  // smooth-scroll tail must not chain pages on its own.
  readonly scrollGate = new ScrollIntentGate({
    onArmAtBottom: () => this.onScrollDown(),
    isAtBottom: () => ScrollIntentGate.nearBottom(document.querySelector('.jc-v3-entity-details-body')),
  });

  jobApplicantStatusList: Array<any>;
  colorLists: any;
  jobDetails: JobModel;
  previousValue_jobDetails: JobModel;
  sliderSubscriber: Subscription;
  @Input() pagelist: string;
  @Input() designVersion: string = 'v2';
  @Output() candidateActivity = new EventEmitter();
  @ViewChild('scrollContainer') scrollContainer: ElementRef;
  isFilterOpen: boolean = false;
  panel: string;
  jobApplicationBlockedStatus: any;

  appliedJob: JobModel;

 From: "SUGGESTED_CANDIDATES" | "FEATURED_CANDIDATE" | "CANDIDATES_FROM_CONNECTION";


  constructor(private util: UtilService, private apiService: ApiService,  private activatedRoute: ActivatedRoute,private router: Router,
    private candidateService: CandidateService, private searchdata: SearchData, private jobService: JobService, private gigsumoService: GigsumoService,
    private modalService: NgbModal,private planService : PricePlanService, private bsModalService: BsModalService) {
    this.colorLists = this.gigsumoService.colorClass
    // this.jobApplicantStatusList = [...GigsumoConstants.JOB_LIST_STATUS];
    this.sliderSubscriber = this.jobService.getSliderToggle().subscribe(value => {
      this.panel = value.panel;
       if (value.panel == 'job applicants') {
        if (!value.value) {
          if (value.filterData != null) {
            this.response = [];
            this.onFilterToggle(value.filterData);
          }
        }
        if (value.value == true && !this.isFilterOpen) {
          this.openFilterSlider();
        } else {
          this.isFilterOpen = false;
          this.closeFilterSlider();
        }
      }
    });
    this.activatedRoute.queryParams.subscribe((param)=>{
      if(param.candidateId){
        this.candidateId = param.candidateId;
      }
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.jobDetails && changes.jobDetails.currentValue) {
      this.jobDetails = changes.jobDetails.currentValue;
      this.previousValue_jobDetails = changes.jobDetails.previousValue;
      this.appliedJob = this.jobDetails;
      this.pageNumber = 0;
      this.response = [];
      // Invalidate any in-flight page fetch — without this, a tab re-click
      // during pagination lets the stale page response append into the
      // just-cleared list and corrupt pageNumber.
      this.fetchGeneration++;
      this.loadAPIcall = false; this.scrollGate.pageLanded();

      // Reset to 'ALL' when job changes (optional - or keep current selection)
      this.selectedStage = 'ALL';
      this.searchText = '';
      this.resetScrollPosition();
      this.getApplicantFilter();
      this.getApplicantsCounts(this.jobDetails);
    }
  }
  userId: any;
  url = AppSettings.photoUrl;
  candidatesApplied: any = []
  candidateSeletedFilter;
  candidateId : string = undefined;
  queryParamData: any;
  applicantsFoundStatus = "Fetching Applicants..."
  readonly GigsumoConstants = GigsumoConstants;
  response: any = [];
  previousSearchAfterKey = null;
  stopscrollFlag: boolean = false
  userType: any;
  messageShown: boolean = false
  obj: any = {
    limit: 10,
    jobId: null,
    pageNumber: 0,
  }
  subscription: Subscription;
  appliedCount: any
  ngOnInit() {

    this.scrollGate.attach();
    this.pageNumber=0;
     this.userType = localStorage.getItem('userType')
    this.subscription = this.jobService.confirmationResult$.subscribe(() => {
      this.getApplicantFilter( );
    });
    this.scrollSubject.pipe(
      debounceTime(100)
    ).subscribe(() => {
      if (this.loadAPIcall || this.stopscrollFlag) return;
      const status = this.jobApplicantStatusList.map(c=>c.itemId);
      this.previousValue_jobDetails=this.jobDetails;
      this.getCandidateList(status.toString());
    });
    this.getApplicantsCounts(this.jobDetails);

    /* COMMENTED OUT: Timeline logic moved to candidate-card component
    // Load timeline filter data for future steps
    this.loadTimelineFilterData();
    */

    this.userId = localStorage.getItem('userId');
   }
   filterApplicantData : any = null;
   loadAPIcall:boolean=false;
  getApplicantFilter() {
    let entireApplyStatusList: any = []
    const default_apply_stages: any = GigsumoConstants.JOB_APPLIED_DEFAULT_STAGES;
    this.loadAPIcall=true;
    this.apiService.create('listvalue/findbyList' , {domain : "JOB_APPLICATION_BUYER_ACTIONS,JOB_APPLICATION_BLOCKING_ACTIONS"}).subscribe(res=>{
      const sorted : Array<any> =  res.data.JOB_APPLICATION_BUYER_ACTIONS && res.data.JOB_APPLICATION_BUYER_ACTIONS.listItems;
      this.filterApplicantData = res.data;
      this.loadAPIcall = false; this.scrollGate.pageLanded();
      if(sorted){
        // Store all available statuses
        entireApplyStatusList = sorted
        .map(x => {
          return {itemId : x.itemId , value : x.value};
        });
        this.tempStatusList = entireApplyStatusList;

        // Check if 'ALL' is selected (default on load)
        if (this.selectedStage === 'ALL' || !this.selectedStage) {
          // Load ALL statuses, not just defaults
          this.jobApplicantStatusList = [...entireApplyStatusList];
          console.log('Loading ALL applicant statuses on initialization:', this.jobApplicantStatusList.length);
        } else {
          // Load only default stages
          this.jobApplicantStatusList = sorted
          .filter(x=>default_apply_stages.includes(x.itemId))
          .map(x => {
            return {itemId : x.itemId , value : x.value};
          });
          console.log('Loading DEFAULT applicant statuses:', this.jobApplicantStatusList.length);
        }

        // Update removedData to reflect current selection
        this.removedData = this.updatedArr();

        // Build the status string for API call
        const statusString = this.jobApplicantStatusList.map(x => x.itemId).toString();

        console.log('Initial filter status string:', statusString);

        // Load candidates with the selected statuses
        if (statusString) {
          this.filterByStatus(statusString);
        } else {
          console.warn('No statuses available to filter');
          this.applicantsFoundStatus = "No filter statuses available.";
        }
      }
     });
  }
  ngOnDestroy(): void {

    this.scrollGate.detach();
    if (this.sliderSubscriber) {
      this.sliderSubscriber.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    // Clear any pending search debounce timer
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = null;
    }
    if (this.scrollSubject) {
      this.scrollSubject.complete();
    }
  }

  // Reset scroll container to top position with smooth behavior.
  // The `@ViewChild('scrollContainer')` ref only binds to the V2 template
  // block (scrollContainer is inside `designVersion !== 'v3'`). For V3,
  // the shared scroll container is `.jc-v3-entity-details-body` owned by
  // the new-job host — fall back to that so search / filter / stage-tab
  // clicks correctly scroll to top in both versions. Without this
  // fallback, applyFilter / selectStage / search in V3 left the viewport
  // mid-list.
  resetScrollPosition(): void {
    if (this.scrollContainer && this.scrollContainer.nativeElement) {
      this.scrollContainer.nativeElement.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    const v3Container = document.querySelector('.jc-v3-entity-details-body') as HTMLElement | null;
    if (v3Container) {
      v3Container.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
  findJob() {
    this.jobService.findByJobId(this.jobDetails.jobId).subscribe(response => {
      this.appliedJob = response.data.jobData;
    });
  }
  private filterToggling = false;

  openFilterSlider() {
    if (this.filterToggling) return;
    this.filterToggling = true;

    if (!this.isFilterOpen) {
      this.isFilterOpen = true;
      this.jobService.setDataForFilter({...this.removedData});
      this.jobService.setSliderToggle(true, 'job applicants', null,false);
    } else {
      this.closeFilterSlider();
    }

    setTimeout(() => { this.filterToggling = false; }, 400);
   }
  closeFilterSlider() {
    if (this.isFilterOpen) {
      this.isFilterOpen = false;
      this.jobService.setSliderToggle(false, 'job applicants', null,false);
    }
   }
  tempStatusList : Array<any> = [];
  onFilterToggle(value: any) {
    this.isFilterOpen = false
    const receivedData = JSON.parse(value);
    const status : Array<any>= receivedData ? receivedData.jobApplicantStatus : null;
    if(status){
      const d =  this.tempStatusList.filter((e) => status.some(v => v === e.itemId));
      this.jobApplicantStatusList = d;
      this.removedData = {}
      this.jobApplicantStatusList.forEach(element => {
          this.removedData[element.itemId] =  true;
      });
    }
    this.stopscrollFlag = false
    this.response = []
    this.pageNumber = 0
    // Reset scroll position to top when filter is applied
    this.resetScrollPosition();
    this.filterByStatus(this.jobApplicantStatusList.map(c=>c.itemId).toString());
  }
  pageNumber:number=0;
  open(values: any) {
    var profiledata: any = {};
    profiledata.userId = localStorage.getItem('userId')
    profiledata.userType = localStorage.getItem('userType')
    this.apiService.create('user/profileDetails', profiledata).subscribe(res => {
      let element: any = {}
      element = res.data.creditConsumptions.find(item => item.creditType === AppSettings.JOB_VIEW)
      if (res.data.creditPoints >= element.points || localStorage.getItem('userType') == 'student' || this.userType == 'JOB_SEEKER') {
        this.util.startLoader();
        this.candidateService.updateCandidateViewed(values).subscribe((res) => {
          this.util.stopLoader();
        }, err => {
          this.util.stopLoader();
        });
      }
    })
  }
  like(values: any) {
    if (values.isProcessingLike) return;
    let datas: any = {};
    datas.candidateId = values.candidateId
    datas.userId = localStorage.getItem('userId');
    values.isProcessingLike = true;
    this.util.startLoader();
    this.apiService.updatePut("candidates/updateCandidateLiked", datas).subscribe((res) => {
      if (res.code == '00000') {
        this.util.stopLoader();
        this.response.forEach(ele => {
          if (res.data.candidateData.candidateId == ele.candidateId) {
            ele.likesCount = res.data.candidateData.likesCount;
            ele.isLiked = true
          }
        })
      }
      values.isProcessingLike = false;
    }, err => {
      values.isProcessingLike = false;
      this.util.stopLoader();
    });
  }
  filterByStatus(status: any) {
    if(status){
      this.getCandidateList(status);
    }else{
      this.applicantsFoundStatus = "Please select appropriate filters to show relevant job applicants";
      this.returnmsgtoActivity();
    }
  }
  responseReceived: boolean = false;
  // Stale-response gate: bumped on every list reset (tab re-click). A fetch
  // captures the value at launch; a reset mid-flight makes the late response
  // a no-op instead of appending old rows into the cleared list.
  private fetchGeneration = 0;
  // API Call
  async getCandidateList(status) {
    this.responseReceived = false;
    const userId = this.getUserId();
    const gen = this.fetchGeneration;
    try {
      if (this.previousValue_jobDetails != undefined && this.jobDetails.jobId != this.previousValue_jobDetails.jobId) {
        this.pageNumber = 0;
        this.response = [];
        this.stopscrollFlag = false;
      }
      const payload = this.createPayload(status, userId);
      let stringArray: string[] = status.split(",");
      localStorage.setItem('jobApplicantStatus', JSON.stringify(stringArray))
      this.loadAPIcall=true;
      const res = await this.apiService.create("candidates/findAppliedCandidates", payload).toPromise();
      if (gen !== this.fetchGeneration) return;
      this.processResponse(res);
    } catch (err) {
      if (gen !== this.fetchGeneration) return;
      this.handleError(err);
    } finally {
      if (gen === this.fetchGeneration) {
        this.loadAPIcall = false; this.scrollGate.pageLanded();
      }
    }
  }
  getUserId() {
    return this.pagelist && this.pagelist !== 'job-applicants' ? localStorage.getItem('userId') : null;
  }
  createPayload(status, userId) {
    return {
      jobId: this.jobDetails.jobId,
      candidatesApplied: this.pagelist == 'candidate-applied' ? this.jobDetails.candidatesApplied : [],
      currentStatus: status,
      userId: userId,
      limit: 10,
      pageNumber: this.pageNumber,
      searchText : this.searchText,
      subContracting: this.jobDetails.businessId != localStorage.getItem('myBusinessId'),
      businessId: localStorage.getItem('myBusinessId')
    };
  }
  processResponse(res) {
    this.loadAPIcall = false; this.scrollGate.pageLanded();
    this.responseReceived = true;
    if (res && res.code === "00000") {
       // Counts are returned alongside the candidate list on every fetch (server
       // field `applicantsCount`) and drive BOTH the summary cards and the sub-tab
       // pills. The server computes them as visibility-aware full-applicant TOTALS
       // across all stages (Business plan via resolved businessId; Free-plan owner
       // via the job.appliedBy pass), so they stay stable when switching sub-tabs
       // and do not collapse to the filtered page. No separate counts call needed.
       const counts = res.data?.applicantsCount;
       if (counts) {
         this.stageCounts.applied   = counts.applied   ?? 0;
         this.stageCounts.inProcess = counts.inProcess ?? 0;
         this.stageCounts.selected  = counts.selected  ?? 0;
         this.stageCounts.offered   = counts.offered   ?? 0;
         this.stageCounts.onboarded = counts.onboarded ?? 0;
         this.stageCounts.all       = counts.all       ?? 0;
       }
       this.processCandidates(res.data.appliedCandidateList);
    } else {
      this.setNoApplicantsFound();
    }
  }

  async processCandidates(candidates) {
    if (candidates.length === 0) {
      this.setNoApplicantsFound();
    } else {
      if (candidates.length < 9) {
        this.stopscrollFlag = true;
      } else {
        this.stopscrollFlag = false;
        this.pageNumber++;
      }

      const combinedCandidates = [...this.response, ...candidates];
      const uniqueCandidatesMap = new Map(combinedCandidates.map(candidate => [candidate.candidateId, candidate]));
      this.response = Array.from(uniqueCandidatesMap.values());

      /* COMMENTED OUT: Timeline loading moved to candidate-card component
      // Load timeline data for newly added candidates
      const newCandidates = candidates.filter(c => !c.timelineEvents);
      newCandidates.forEach(candidate => {
        this.loadTimelineForCandidate(candidate);
      });
      */

      // Calculate stage counts after loading candidates
      // this.calculateStageCounts();

      // i removed the vertical timeline ,so the check box and initial selection are commented
      // this.initialSelected();
      this.searchdata.setNUllCheck(this.response.length > 0 ? "notNull" : "null");
    }
  }

  /* COMMENTED OUT: Timeline logic moved to candidate-card component
  // Load timeline data for a specific candidate
  loadTimelineForCandidate(candidate: any) {
    if (!candidate?.candidateId || !this.jobDetails?.jobId) {
      console.log('Missing candidateId or jobId for timeline load');
      return;
    }

    const payload = {
      entityId: this.jobDetails.jobId,
      entityType: "JOB",
      limit: 20,
      searchAfterKey: null,
      activityOn: candidate.candidateId,
      parentActivity: "JOB_APPLICATION,CANDIDATE_INVITATION",
      owner: this.jobDetails.jobPostedBy === localStorage.getItem('userId')
    };

    console.log('Loading timeline for candidate:', candidate.candidateId, payload);

    this.apiService.create("jobs/findTimeLines", payload).subscribe(
      res => {
        if (res && res.code === "00000" && res.data?.timeLines) {
          candidate.timelineEvents = res.data.timeLines || [];
          this.processTimelineForCandidate(candidate);
          console.log('Timeline loaded for:', candidate.candidateId, candidate.timelineEvents);
          console.log('Timeline stages:', candidate.timelineStages);

          // Force Angular change detection by updating the response array reference
          this.response = [...this.response];
          console.log('✅ Change detection triggered after timeline load');
        } else {
          candidate.timelineEvents = [];
          candidate.timelineDates = {};
          console.log('No timeline data for:', candidate.candidateId);
        }
      },
      err => {
        console.error('Timeline API error for candidate:', candidate.candidateId, err);
        candidate.timelineEvents = [];
        candidate.timelineDates = {};
      }
    );
  }

  // Process timeline events for a candidate - COMPLETELY REWRITTEN
  processTimelineForCandidate(candidate: any) {
    if (!candidate.timelineEvents || candidate.timelineEvents.length === 0) {
      candidate.timelineDates = {};
      candidate.mergedTimelineData = [];
      candidate.timelineStages = this.getDefaultTimelineStages();
      return;
    }

    console.log('🔍 Processing timeline for candidate:', candidate.candidateId);
    console.log('📋 Raw timeline events:', candidate.timelineEvents);
    console.log('📋 Job application order list:', this.jobApplicationListValues);

    // STEP 1: Order all timeline events based on the JOB_APPLICATION_ACTIVITY order from API
    const orderedEvents = this.orderTimelineEventsByAPI(candidate.timelineEvents);
    console.log('✅ Ordered events:', orderedEvents);

    // STEP 2: Group events into stages and identify rejection points
    const groupedStages = this.groupEventsIntoStages(orderedEvents);
    console.log('✅ Grouped stages:', groupedStages);

    // STEP 3: Build timeline stages with rejection handling
    candidate.timelineStages = this.buildTimelineStagesFromGroupedEvents(groupedStages);
    console.log('✅ Final timeline stages:', candidate.timelineStages);

    // Set legacy date properties for backward compatibility
    candidate.timelineDates = {};
    candidate.timelineStages.forEach((stage: any) => {
      if (stage.date) {
        candidate.timelineDates[stage.id] = stage.date;
      }
    });

    console.log('🎯 Timeline processing complete for:', candidate.candidateId);
  }

  // STEP 1: Order timeline events by JOB_APPLICATION_ACTIVITY API order
  orderTimelineEventsByAPI(events: any[]): any[] {
    if (!this.jobApplicationListValues || this.jobApplicationListValues.length === 0) {
      console.warn('⚠️ No jobApplicationListValues available, returning events as-is');
      return events;
    }

    // Create a map of activityType -> order
    const orderMap = new Map<string, number>();
    this.jobApplicationListValues.forEach((item: any) => {
      if (item.itemId && item.order !== undefined && item.order !== null) {
        orderMap.set(item.itemId, item.order);
      }
    });

    console.log('📊 Order map:', orderMap);

    // Sort events by order (events without order go to the end)
    const orderedEvents = [...events].sort((a, b) => {
      const orderA = orderMap.get(a.activityType) ?? 9999;
      const orderB = orderMap.get(b.activityType) ?? 9999;

      // If same order, sort by date (earliest first)
      if (orderA === orderB) {
        return new Date(a.createdOn).getTime() - new Date(b.createdOn).getTime();
      }

      return orderA - orderB;
    });

    return orderedEvents;
  }

  // STEP 2: Group events into stages (Applied, Shortlisted, Interview, Selected, Offered, Onboarded, Rejected)
  groupEventsIntoStages(orderedEvents: any[]): any {
    const stageMapping = {
      'APPLIED': {
        id: 'APPLIED',
        label: 'Applied',
        activityTypes: ['JOB-APPLIED', 'APPLIED']
      },
      'SHORTLISTED': {
        id: 'SHORTLISTED',
        label: 'Shortlisted',
        activityTypes: ['CANDIDATE-SHORTLISTED', 'SHORTLISTED']
      },
      'INTERVIEW': {
        id: 'INTERVIEW',
        label: 'Interview',
        activityTypes: ['INTERVIEW-SCHEDULED', 'INTERVIEW-ACCEPTED', 'INTERVIEW-REJECTED', 'INTERVIEW SCHEDULED', 'L1-INTERVIEW', 'L2-INTERVIEW', 'L3-INTERVIEW']
      },
      'SELECTED': {
        id: 'SELECTED',
        label: 'Selected',
        activityTypes: ['CANDIDATE-SELECTED', 'SELECTED']
      },
      'OFFERED': {
        id: 'OFFERED',
        label: 'Offered',
        activityTypes: ['OFFERED', 'OFFER-ACCEPTED', 'OFFER-DECLINED', 'OFFER-WITHDRAWN']
      },
      'ONBOARDED': {
        id: 'ONBOARDED',
        label: 'Onboarded',
        activityTypes: ['ONBOARDED', 'PREONBOARDED', 'PRE-ONBOARDED']
      },
      'REJECTED': {
        id: 'REJECTED',
        label: 'Rejected',
        activityTypes: ['PROFILE-REJECTED', 'APPLICATION-REJECTED', 'CANDIDATE-REJECTED']
      }
    };

    // Build reverse lookup: activityType -> stageId
    const activityToStage = new Map<string, string>();
    Object.entries(stageMapping).forEach(([stageId, config]: any) => {
      config.activityTypes.forEach((activityType: string) => {
        activityToStage.set(activityType, stageId);
      });
    });

    // Group events by stage
    const grouped: any = {
      APPLIED: { events: [], hasRejection: false, latestEvent: null },
      SHORTLISTED: { events: [], hasRejection: false, latestEvent: null },
      INTERVIEW: { events: [], hasRejection: false, latestEvent: null },
      SELECTED: { events: [], hasRejection: false, latestEvent: null },
      OFFERED: { events: [], hasRejection: false, latestEvent: null },
      ONBOARDED: { events: [], hasRejection: false, latestEvent: null },
      REJECTED: { events: [], hasRejection: false, latestEvent: null }
    };

    orderedEvents.forEach((event: any) => {
      const stageId = activityToStage.get(event.activityType);

      if (stageId && grouped[stageId]) {
        grouped[stageId].events.push(event);

        // Check if this is a rejection event
        const isRejection = this.isNegativeStatus(event.activityType);
        if (isRejection) {
          grouped[stageId].hasRejection = true;
          console.log(`🚨 Rejection detected: ${event.activityType} in stage ${stageId}`);
        }

        // Track the latest event (most recent by order/date)
        if (!grouped[stageId].latestEvent) {
          grouped[stageId].latestEvent = event;
        } else {
          // Compare by date if same stage has multiple events
          const currentDate = new Date(event.createdOn).getTime();
          const latestDate = new Date(grouped[stageId].latestEvent.createdOn).getTime();
          if (currentDate > latestDate) {
            grouped[stageId].latestEvent = event;
          }
        }

        console.log(`  ✓ Event ${event.activityType} → ${stageId} (rejection: ${isRejection})`);
      } else {
        console.warn('⚠️ Unknown activity type:', event.activityType);
      }
    });

    return grouped;
  }

  // STEP 3: Build timeline stages from grouped events with rejection handling
  buildTimelineStagesFromGroupedEvents(groupedStages: any): any[] {
    // Build stageOrder dynamically - only include REJECTED if it has events
    let stageOrder = ['APPLIED', 'SHORTLISTED', 'INTERVIEW', 'SELECTED', 'OFFERED', 'ONBOARDED'];

    // Insert REJECTED stage after APPLIED if it has events
    if (groupedStages.REJECTED && groupedStages.REJECTED.events.length > 0) {
      stageOrder = ['APPLIED', 'REJECTED', 'SHORTLISTED', 'INTERVIEW', 'SELECTED', 'OFFERED', 'ONBOARDED'];
    }

    const stages: any[] = [];

    let rejectionFound = false;
    let hasAnyRejection = false;

    // First pass: Check if there's ANY rejection in the timeline
    for (let i = 0; i < stageOrder.length; i++) {
      const stageData = groupedStages[stageOrder[i]];
      if (stageData && stageData.hasRejection) {
        hasAnyRejection = true;
        break;
      }
    }

    console.log(`🔍 Has any rejection in timeline: ${hasAnyRejection}`);

    // Build stages in order
    for (let i = 0; i < stageOrder.length; i++) {
      const stageId = stageOrder[i];
      const stageData = groupedStages[stageId];

      // If rejection already found, STOP - don't add any more stages
      if (rejectionFound) {
        console.log(`🛑 Skipping stage ${stageId} - rejection already found, timeline ends`);
        break;
      }

      // Determine label
      const labelMap: any = {
        'APPLIED': 'Applied',
        'REJECTED': 'Rejected',
        'SHORTLISTED': 'Shortlisted',
        'INTERVIEW': 'Interview',
        'SELECTED': 'Selected',
        'OFFERED': 'Offered',
        'ONBOARDED': 'Onboarded'
      };

      const hasEvents = stageData.events.length > 0;
      const latestEvent = stageData.latestEvent;
      const baseLabel = labelMap[stageId] || stageId;

      // LOGIC: If rejection exists anywhere, skip empty stages
      //        If no rejection exists, show ALL stages (completed + future)
      if (!hasEvents && hasAnyRejection) {
        console.log(`⏭️ Skipping empty stage ${stageId} (rejection exists in timeline)`);
        continue;
      }

      // Determine if this is a rejection
      const isNegative = latestEvent ? this.isNegativeStatus(latestEvent.activityType) : false;

      // For rejected events, show the specific rejection name
      // For normal events, use the stage label
      let displayLabel = baseLabel;
      if (isNegative && latestEvent) {
        const eventName = this.getTimelineFilterValue(latestEvent.activityType);
        displayLabel = eventName || latestEvent.activityType || baseLabel;
      }

      console.log(`✅ Stage ${stageId}: hasEvents=${hasEvents}, isNegative=${isNegative}, displayLabel=${displayLabel}`);

      // Create stage object
      const stage: any = {
        id: stageId,
        label: displayLabel,
        baseLabel: baseLabel,
        date: latestEvent ? new Date(latestEvent.createdOn) : null,
        completed: hasEvents,
        active: false,
        notion: hasEvents ? 'default' : 'future',
        isNegative: isNegative,
        isTerminal: false,
        activityType: latestEvent?.activityType,
        events: stageData.events
      };

      // Determine notion based on latest event (for completed stages)
      if (latestEvent) {
        stage.notion = this.determineNotion(latestEvent.activityType);
      }

      // If this stage has a rejection, mark it as terminal and STOP
      if (isNegative) {
        rejectionFound = true;
        stage.isTerminal = true;
        stage.active = true;
        console.log(`🛑 REJECTION at stage: ${stageId} (${displayLabel}) - STOPPING HERE`);
        stages.push(stage);
        break;
      }

      // Add stage to timeline
      stages.push(stage);
    }

    // NEW LOGIC: Fill in skipped stages up to highest completed
    let highestCompletedIndex = -1;

    // Find the highest completed stage (with actual events)
    for (let i = stages.length - 1; i >= 0; i--) {
      if (stages[i].completed && !stages[i].isNegative && !rejectionFound) {
        highestCompletedIndex = i;
        break;
      }
    }

    console.log(`🔍 Highest completed stage index: ${highestCompletedIndex}`);

    // Mark all stages up to the highest as completed (fill in gaps for skipped stages)
    if (highestCompletedIndex >= 0 && !rejectionFound) {
      for (let i = 0; i <= highestCompletedIndex; i++) {
        if (!stages[i].isNegative) {
          // Store whether this was an actual event or implied
          const wasActuallyCompleted = stages[i].completed;

          stages[i].completed = true;
          stages[i].notion = 'default';

          // Mark as implied if it didn't have actual events (skipped stage)
          if (!wasActuallyCompleted) {
            stages[i].isImplied = true;

            // Find the next actually completed stage and copy its date
            let nextActualDate = null;
            for (let j = i + 1; j <= highestCompletedIndex; j++) {
              if (!stages[j].isImplied && stages[j].date) {
                nextActualDate = stages[j].date;
                break;
              }
            }

            // Set the date to the next actual completion date
            if (nextActualDate) {
              stages[i].date = nextActualDate;
              console.log(`✨ Stage ${stages[i].id} marked as implied completion (skipped) with date from next actual stage`);
            } else {
              console.log(`✨ Stage ${stages[i].id} marked as implied completion (skipped) - no date available`);
            }
          }
        }
      }

      // Mark the highest completed stage as active
      stages[highestCompletedIndex].active = true;
      console.log(`✅ Stage ${stages[highestCompletedIndex].id} marked as active (highest)`);
    }

    // If rejection found, it's already marked as active in the rejection logic above
    if (rejectionFound) {
      console.log(`🛑 Rejection found - timeline ends at rejection point`);
    }

    console.log('🎯 Final timeline:', stages.map(s => `${s.id}(${s.label}, completed:${s.completed}, implied:${s.isImplied || false}, negative:${s.isNegative})`));
    return stages;
  }

  // Build structured timeline stages array for HTML loop with negative handling (OLD METHOD - DEPRECATED)
  buildTimelineStages(timelineDates: any, stepNotions: any) {
    const allStages = [
      {
        id: 'APPLIED',
        label: 'Applied',
        date: timelineDates['APPLIED'] || null,
        completed: !!timelineDates['APPLIED'],
        active: false,
        notion: stepNotions['APPLIED'] || 'default',
        isNegative: stepNotions['APPLIED'] === 'negative',
        isTerminal: false
      },
      {
        id: 'SHORTLISTED',
        label: 'Shortlisted',
        date: timelineDates['SHORTLISTED'] || null,
        completed: !!timelineDates['SHORTLISTED'],
        active: false,
        notion: stepNotions['SHORTLISTED'] || 'progress',
        isNegative: stepNotions['SHORTLISTED'] === 'negative',
        isTerminal: false
      },
      {
        id: 'INTERVIEW',
        label: 'Interview',
        date: timelineDates['INTERVIEW'] || null,
        completed: !!timelineDates['INTERVIEW'],
        active: false,
        notion: stepNotions['INTERVIEW'] || 'progress',
        isNegative: stepNotions['INTERVIEW'] === 'negative',
        isTerminal: false
      },
      {
        id: 'SELECTED',
        label: 'Selected',
        date: timelineDates['SELECTED'] || null,
        completed: !!timelineDates['SELECTED'],
        active: false,
        notion: stepNotions['SELECTED'] || 'positive',
        isNegative: stepNotions['SELECTED'] === 'negative',
        isTerminal: false
      },
      {
        id: 'OFFERED',
        label: 'Offered',
        date: timelineDates['OFFERED'] || null,
        completed: !!timelineDates['OFFERED'],
        active: false,
        notion: stepNotions['OFFERED'] || 'positive',
        isNegative: stepNotions['OFFERED'] === 'negative',
        isTerminal: false
      },
      {
        id: 'ONBOARDED',
        label: 'Onboarded',
        date: timelineDates['ONBOARDED'] || null,
        completed: !!timelineDates['ONBOARDED'],
        active: false,
        notion: stepNotions['ONBOARDED'] || 'positive',
        isNegative: stepNotions['ONBOARDED'] === 'negative',
        isTerminal: false
      }
    ];

    // Check if ANY stage has a negative notion (rejection)
    let negativeStageIndex = -1;
    for (let i = 0; i < allStages.length; i++) {
      if (allStages[i].isNegative && allStages[i].completed) {
        negativeStageIndex = i;
        break;
      }
    }

    // If negative status found, cut timeline at that point
    let stages = allStages;
    if (negativeStageIndex !== -1) {
      // Only include stages up to and including the negative one
      stages = allStages.slice(0, negativeStageIndex + 1);
      // Mark the negative stage as active (terminal stage)
      stages[negativeStageIndex].active = true;
      stages[negativeStageIndex].isTerminal = true;  // Flag to indicate timeline ends here

      console.log(`Timeline terminated at ${stages[negativeStageIndex].label} (negative status)`);
    } else {
      // No negative status - normal flow
      // Find the last completed stage and mark it as active
      for (let i = stages.length - 1; i >= 0; i--) {
        if (stages[i].completed) {
          stages[i].active = true;
          break;
        }
      }
    }

    return stages;
  }

  // Get default timeline stages when no events exist
  getDefaultTimelineStages() {
    return [
      { id: 'APPLIED', label: 'Applied', date: null, completed: false, active: false, notion: 'default', isNegative: false, isTerminal: false },
      { id: 'SHORTLISTED', label: 'Shortlisted', date: null, completed: false, active: false, notion: 'progress', isNegative: false, isTerminal: false },
      { id: 'INTERVIEW', label: 'Interview', date: null, completed: false, active: false, notion: 'progress', isNegative: false, isTerminal: false },
      { id: 'SELECTED', label: 'Selected', date: null, completed: false, active: false, notion: 'positive', isNegative: false, isTerminal: false },
      { id: 'OFFERED', label: 'Offered', date: null, completed: false, active: false, notion: 'positive', isNegative: false, isTerminal: false },
      { id: 'ONBOARDED', label: 'Onboarded', date: null, completed: false, active: false, notion: 'positive', isNegative: false, isTerminal: false }
    ];
  }

  // Create merged timeline data with past events + future steps
  createMergedTimelineForCandidate(candidate: any) {
    candidate.mergedTimelineData = [];

    // Normalize activity types (SHORTLISTED → CANDIDATE-SHORTLISTED)
    const normalizedEvents = candidate.timelineEvents.map((event: any) => {
      if (event.activityType === "SHORTLISTED") {
        return { ...event, activityType: "CANDIDATE-SHORTLISTED" };
      }
      return event;
    });

    // Process existing timeline events (reverse order - oldest first for display)
    const reversedEvents = [...normalizedEvents].reverse();

    // Track if we encounter a negative status ANYWHERE in the timeline
    let hasNegativeStatus = false;
    let negativeStatusIndex = -1;

    reversedEvents.forEach((event: any, index: number) => {
      const notion = event.notion || this.determineNotion(event.activityType);

      // Check if this is a negative status
      if (notion === 'negative') {
        hasNegativeStatus = true;
        negativeStatusIndex = index;
      }

      candidate.mergedTimelineData.push({
        title: this.getTimelineFilterValue(event.activityType) || event.activityType,
        createdOn: event.createdOn,
        notion: notion,
        showIcon: true,
        showDate: true,
        showNumber: false,
        order: index,
        activityType: event.activityType,
        isNegative: notion === 'negative'  // Mark negative events
      });
    });

    // Only add future activities if there's NO negative status in the timeline
    if (!hasNegativeStatus && this.jobApplicationListValues.length > 0) {
      const sortedFutureActivities = [...this.jobApplicationListValues]
        .filter(x => x.order !== undefined && x.order !== null)
        .sort((a, b) => a.order - b.order);

      // Find the most recent non-negative activity to determine which future steps to show
      let lastCompletedOrder = -1;
      if (normalizedEvents.length > 0) {
        // Get the most recent event (first in normalizedEvents)
        const recentActivity = normalizedEvents[0];
        const currentItem = this.jobApplicationListValues.find(x => x.itemId === recentActivity.activityType);
        if (currentItem && currentItem.order !== undefined) {
          lastCompletedOrder = currentItem.order;
        }
      }

      // Add future steps that come after the last completed step
      sortedFutureActivities
        .filter(activity => activity.order > lastCompletedOrder)
        .forEach((futureActivity, index) => {
          candidate.mergedTimelineData.push({
            title: futureActivity.value || futureActivity.item,
            notion: "future",
            showIcon: false,
            showDate: false,
            showNumber: true,
            order: reversedEvents.length + index,
            activityType: futureActivity.itemId,
            isNegative: false
          });
        });
    }

    console.log('Merged timeline created:', {
      candidateId: candidate.candidateId,
      hasNegativeStatus: hasNegativeStatus,
      negativeAt: negativeStatusIndex,
      totalEvents: candidate.mergedTimelineData.length,
      events: candidate.mergedTimelineData
    });
  }

  // Determine notion based on activity type
  determineNotion(activityType: string): string {
    const negativeStatuses = [
      'REJECTED',
      'INTERVIEW-REJECTED',
      'OFFER-DECLINED',
      'OFFER-WITHDRAWN',
      'CANDIDATE-REJECTED',
      'APPLICATION-REJECTED',
      'PROFILE-REJECTED'
    ];
    const progressStatuses = [
      'CANDIDATE-SHORTLISTED',
      'SHORTLISTED',
      'INTERVIEW-SCHEDULED',
      'INTERVIEW-ACCEPTED',
      'INTERVIEW SCHEDULED'
    ];
    const positiveStatuses = [
      'CANDIDATE-SELECTED',
      'SELECTED',
      'OFFERED',
      'OFFER-ACCEPTED',
      'ONBOARDED',
      'PREONBOARDED',
      'PRE-ONBOARDED'
    ];

    if (negativeStatuses.some(neg => activityType.includes(neg) || neg.includes(activityType))) return 'negative';
    if (progressStatuses.includes(activityType)) return 'progress';
    if (positiveStatuses.includes(activityType)) return 'positive';
    return 'default';
  }

  // Check if status is negative (rejection)
  isNegativeStatus(activityType: string): boolean {
    const negativeKeywords = [
      'REJECTED',
      'REJECT',
      'DECLINED',
      'DECLINE',
      'WITHDRAWN',
      'WITHDRAW'
    ];

    // Check if activityType contains any negative keyword
    return negativeKeywords.some(keyword =>
      activityType.toUpperCase().includes(keyword)
    );
  }

  // Get timeline filter value for display
  getTimelineFilterValue(key: string): string | null {
    if (Array.isArray(this.filterStatusData)) {
      const find = this.filterStatusData.find(c => c.itemId === key);
      return find ? find.value : null;
    }
    return null;
  }

  // Get tooltip text for timeline stage (differentiates actual vs implied completions)
  getStageTooltip(stage: any): string {
    if (!stage) return '';

    if (stage.isImplied && stage.date) {
      const dateStr = new Date(stage.date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        timeZone: this.getUserTimeZone()
      });
      return `${stage.label} - Skipped (reached higher stage on ${dateStr})`;
    } else if (stage.isImplied) {
      return `${stage.label} - Skipped (implied completion)`;
    } else if (stage.completed && stage.date) {
      const dateStr = new Date(stage.date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        timeZone: this.getUserTimeZone()
      });
      return `${stage.label} - Completed on ${dateStr}`;
    } else if (stage.completed) {
      return `${stage.label} - Completed`;
    } else if (stage.isNegative) {
      return `${stage.label} - Process ended here`;
    } else {
      return `${stage.label} - Not yet reached`;
    }
  }

  // Resolve the user's configured IANA timezone — same source of truth as
  // TimezoneDatePipe / dashboard-mappers: localStorage 'timezonedate', falling
  // back to the browser zone only when it is unset/'null'/'undefined'. Used so
  // the stage-timeline dates render in the user's configured zone, not local.
  private getUserTimeZone(): string {
    const stored = localStorage.getItem('timezonedate');
    if (!stored || stored === 'null' || stored === 'undefined' || stored.trim() === '') {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    return stored;
  }


  // ============================================================
  // COMMENTED OUT: All timeline logic moved to candidate-card component
  // ============================================================
  /*
  // Load filter data for timeline (future steps)
  loadTimelineFilterData() {
    this.apiService.create('listvalue/findbyList', {
      domain: "TIMELINE_ACTIVITY_VALUES,JOB_APPLICATION_ACTIVITY,BLOCKING_ACTIVITY_LIST"
    }).subscribe(res => {
      // Store timeline activity labels
      const sorted: Array<any> = res.data.TIMELINE_ACTIVITY_VALUES?.listItems || [];
      this.blockingListValues = res.data.BLOCKING_ACTIVITY_LIST?.listItems || [];

      if (sorted) {
        this.filterStatusData = sorted.map(x => ({
          itemId: x.itemId,
          value: x.value
        }));
      }

      // Store future job application activities (for future steps)
      let jobApplicationListValues: any[] = res.data.JOB_APPLICATION_ACTIVITY?.listItems || [];
      if (Array.isArray(jobApplicationListValues) && jobApplicationListValues.length > 0) {
        this.jobApplicationListValues = jobApplicationListValues.filter(x =>
          x.order !== undefined && x.order !== null
        );
      }

      console.log('Timeline filter data loaded:', {
        filterStatusData: this.filterStatusData,
        jobApplicationListValues: this.jobApplicationListValues
      });
    }, err => {
      console.error('Error loading timeline filter data:', err);
    });
  }
  END OF COMMENTED TIMELINE LOGIC */

  removeDuplicateCandidates(candidates) {
    return candidates.filter((obj, pos, arr) => arr.findIndex(t => t.candidateId === obj.candidateId) === pos);
  }
  setNoApplicantsFound() {
    this.stopscrollFlag = true;
    this.applicantsFoundStatus = this.pagelist !== 'candidate-applied' ? "Couldn't find any job applicants." : "You have not applied to this job yet.";
    this.messageShown = true;
    if(this.pageNumber==0){
      this.returnmsgtoActivity();
    }
  }
  handleError(err) {
    // Specific error handling based on the error object
    // For example, if (err.status === 500) { // Handle server error }
    this.loadAPIcall = false; this.scrollGate.pageLanded();
    this.stopscrollFlag = true;
    this.applicantsFoundStatus = "Couldn't find any Applicants.";
    this.messageShown = true;
  }
  count: number = 0;
  passCandidateId(item) {
    // Checkbox selected status update
   this.getUpdate(item);
  }
  // message retunto activity
  returnmsgtoActivity(){
    let item :any={};
    item.parentType="JOB_APPLICATION,CANDIDATE_INVITATION";
    item.tab="job-applicants";
    item.responseMessage=this.applicantsFoundStatus;
    item.data = [];
    this.parentValueChange.emit(item)
  }
// getting values from candidate card checkbox after i will pass to parent
  @Output() parentValueChange = new EventEmitter<any>();
  pushtoparentcomponent(item) {
    item.parentType="JOB_APPLICATION,CANDIDATE_INVITATION";
    this.parentValueChange.emit(item)
    this.getUpdate(item);

   }
   initialSelected(){
    console.log("intitlaized " , this.candidateId);

    this.response.forEach((element,index) => {
      if(index === 0 && this.candidateId === undefined){
        element.isSelected=true;
        this.pushtoparentcomponent(element)
      }
      else if(this.candidateId === element.candidateId){
        element.isSelected = true;
        this.pushtoparentcomponent(element)
      }
    });
  }
  getUpdate(candId) {
    if (!Array.isArray(this.response)) {
      return;
    }
    //update activitydate based on the status without refresh by monisha
    this.response = this.response.map(element => {
      if (element.candidateId === candId.candidateId) {
        return { ...element, isSelected: true, activityDate: candId.activityDate }; // ✅ Update only the matched candidate
      }
      return { ...element, isSelected: false };
    });
  }

  requestResume(value) {
    var data: any = {}
    data.candidateId = value.candidateId
    data.resumeRequestLogs = [{ "jobId": this.jobDetails.jobId, "requestedBy": localStorage.getItem('userId') }]
    this.util.startLoader()
    this.apiService.updatePut('candidates/updateResumeRequests', data).subscribe(res => {
      if (res.code == '00000') {
        this.util.stopLoader()
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Resume request sent",
          showConfirmButton: false,
          timer: 2000,
        })
      }
    }, err => {
      this.util.stopLoader();
    });
  }
  scrollSubject = new Subject<void>();
  onScrollDown() {
    if (!this.loadAPIcall && !this.stopscrollFlag && this.scrollGate.armed) {
      this.scrollSubject.next();
    }
  }
  async updatestatus(name, value, index) {
    // ----- TEMPORARY free-plan gate (applicant-menu path; mirrors job-card / candidate-card).
    // OFFER-ACCEPTED -> candidate owner accepting -> check the CANDIDATE OWNER's plan.
    // CANDIDATE-SELECTED / SELECTED / OFFERED / PRE-ONBOARDED / ONBOARDED -> job owner advancing ->
    // check the acting (logged-in) business's plan. Only code 10004 (free/null plan) blocks; any
    // other code or error proceeds, so Business-plan (paid) users are never blocked. -----
    {
      const planStatus = (name || '').toString().toUpperCase();
      const ownerPlanStatuses = ['OFFER-ACCEPTED'];
      const actorPlanStatuses = ['CANDIDATE-SELECTED', 'SELECTED', 'OFFERED', 'PRE-ONBOARDED', 'ONBOARDED'];
      if (ownerPlanStatuses.includes(planStatus) || actorPlanStatuses.includes(planStatus)) {
        this.util.startLoader();
        try {
          const planBody = ownerPlanStatuses.includes(planStatus)
            ? { candidateId: value?.candidateId, businessId: '' }
            : { candidateId: '', businessId: localStorage.getItem('myBusinessId') || '' };
          const planRes: any = await this.apiService.create('contractCandidate/validate-business-plan', planBody).toPromise();
          if (planRes?.code === '10004') {
            this.util.stopLoader();
            Swal.fire({
              icon: 'warning',
              title: 'Business Plan Required',
              html: "You can't proceed on the Free plan. Please purchase a Business Plan to continue.",
              confirmButtonText: 'OK'
            });
            return;
          }
        } catch (e) { /* don't hard-block on a plan-check error */ }
        this.util.stopLoader();
      }
    }

    this.util.startLoader();
    // Payload parity with candidate-card.component.ts updatestatus()
    // (line 1771-1785). Earlier this only sent the 3-field minimum
    // (candidateId / jobId / currentStatus) — which the backend accepts
    // but treats as a degraded path; the full payload below is what the
    // V2 row-design has been sending all along, and matches the field
    // set the activity log + email notification handlers on the server
    // expect for status updates triggered from the applicant list.
    const data: any = {
      candidateId: value?.candidateId,
      jobId: this.jobDetails?.jobId,
      currentStatus: name,
      candidateName: [value?.firstName, value?.lastName].filter(Boolean).join(' ').trim(),
      jobTitle: this.jobDetails?.jobTitle || value?.jobTitle || '',
      createdByUserName: this.jobDetails?.postedByUserName || '',
      createdBy: value?.createdBy || '',
      email: value?.user?.email || value?.email || '',
    };
    this.apiService.create('candidates/updatejobAppliedStatus', data).subscribe(res => {
      this.util.stopLoader()
      if (res.code == '00000') {
        //  this.response[index].currentStatus=res.data.jobData.currentStatus;
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Status successfully Updated.",
          showConfirmButton: false,
          timer: 2000,
        });
        value.currentStatus = name;
        /* COMMENTED OUT: Timeline refresh now handled by candidate-card component
        this.loadTimelineForCandidate(value);
        */
        this.refreshApplicantList();
      }else if(res.code =='99998'){
        Swal.fire('Please complete the document verification process', '','info');
      } else {
        // Surface non-success codes so users see feedback instead of a
        // silent failure when the backend rejects the request (the
        // earlier behaviour was to just `stopLoader()` and do nothing).
        Swal.fire({
          icon: 'error',
          title: 'Status update failed',
          text: res?.message || 'The candidate status could not be updated.',
          showConfirmButton: true
        });
      }
    }, err => {
      this.util.stopLoader();
      Swal.fire({
        icon: 'error',
        title: 'Status update failed',
        text: 'A network error prevented the status update. Please try again.',
        showConfirmButton: true
      });
    });
  }
  removedData : any;
  updatedArr() {
    const group = {};
    let arr = [...this.jobApplicantStatusList.map(x=>x.itemId)];
    arr.forEach((element)=>{
      group[element] = true;
    });
    return group;
  }
  removeEntity(value, index) {
    this.stopscrollFlag = false
    this.response = []
    this.obj.pageNumber = 0
    this.jobApplicantStatusList.splice(index, 1);
    this.removedData[value] = false;
    const status = this.jobApplicantStatusList.map(x=>x.itemId);
    this.filterByStatus(status.toString());
  }
  widgetstick: boolean = false
  @HostListener("window:scroll")
  handleScroll() {
    const windowScroll = window.pageYOffset;
    if (windowScroll >= 5) {
      this.widgetstick = true;
    } else {
      this.widgetstick = false;
    }
  }

  // New properties for the custom table view
  stageCounts = {
    applied: 0,
    inProcess: 0,
    selected: 0,
    offered: 0,
    onboarded: 0,
    all:0
  };
  searchText: string = '';
  selectedStageFilter: string = 'All Stages';
  showStageFilterDropdown: boolean = false;
  searchExpanded: boolean = false;
  private searchDebounceTimer: any = null;

  // Calculate stage counts
  // calculateStageCounts() {
  //   this.stageCounts = {
  //     applied: 0,
  //     inProcess: 0,
  //     selections: 0,
  //     offers: 0,
  //     onboards: 0
  //   };

  //   this.response.forEach(candidate => {
  //     const status = candidate.currentStatus?.toUpperCase() || 'APPLIED';

  //     if (status === 'APPLIED') {
  //       this.stageCounts.applied++;
  //     } else if (status === 'SHORTLISTED' || status === 'INTERVIEW SCHEDULED' || status === 'INTERVIEW REJECTED') {
  //       this.stageCounts.inProcess++;
  //     } else if (status === 'SELECTED') {
  //       this.stageCounts.selections++;
  //     } else if (status === 'OFFERED' || status === 'OFFER DECLINED' || status === 'OFFER WITHDRAWN') {
  //       this.stageCounts.offers++;
  //     } else if (status === 'ONBOARDED' || status === 'PREONBOARDED') {
  //       this.stageCounts.onboards++;
  //     }
  //   });
  // }

  // Filter candidates based on search with debouncing
  filterCandidates() {
    // Clear existing timer
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
    }

    // Set new timer with 500ms debounce
    this.searchDebounceTimer = setTimeout(() => {
      // Implement search logic
      if (this.searchText === '' || this.searchText.trim() !== '') {
        // Reset pagination for new search
        this.pageNumber = 0;
        this.response = [];
        this.stopscrollFlag = false;

        // Reset scroll position to top when search is performed
        this.resetScrollPosition();

        // Get the current status list
        const sts = JSON.parse(localStorage.getItem('jobApplicantStatus') || '[]');

        if (sts.length > 0) {
          this.filterByStatus(sts.join(','));
        } else {
          // If no status in localStorage, use current jobApplicantStatusList
          const statusString = this.jobApplicantStatusList.map(c => c.itemId).toString();
          if (statusString) {
            this.filterByStatus(statusString);
          } else {
            this.applicantsFoundStatus = "Please select a filter to search candidates.";
            this.stopscrollFlag = true;
          }
        }
      }
    }, 500); // 500ms debounce delay
  }

  // Toggle search expansion
  toggleSearch() {
    this.searchExpanded = !this.searchExpanded;
    if (this.searchExpanded) {
      // Focus input after expansion animation
      setTimeout(() => {
        const searchInput = document.getElementById('job_applicants_search') as HTMLInputElement;
        if (searchInput) {
          searchInput.focus();
        }
      }, 300);
    }
  }

  // Handle search focus
  onSearchFocus() {
    this.searchExpanded = true;
  }

  // Handle search blur
  onSearchBlur() {
    // Only collapse if search is empty
    if (!this.searchText || this.searchText.trim() === '') {
      setTimeout(() => {
        this.searchExpanded = false;
      }, 200);
    }
  }

  // Toggle stage filter dropdown
  toggleStageFilter() {
    this.showStageFilterDropdown = !this.showStageFilterDropdown;
  }

  // Select stage filter
  selectStageFilter(stage: string) {
    this.selectedStageFilter = stage;
    this.showStageFilterDropdown = false;
    // Apply filtering logic
  }

  // Get color for avatar initials
  getColor(firstName: string, lastName: string): string {
    const name = `${firstName || ''} ${lastName || ''}`;
    const colors = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FECA57'];
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
  }

  // Get initials from name
  getInitials(firstName: string, lastName: string): string {
    const first = firstName?.charAt(0)?.toUpperCase() || '';
    const last = lastName?.charAt(0)?.toUpperCase() || '';
    return first + last;
  }

  // Get stage style based on status - using existing color definitions
  getStageStyle(status: string): any {
    if (!status) {
      status = 'APPLIED';
    }

    // Normalize status for matching
    const normalizedStatus = status.toUpperCase().replace(/ /g, ' ');

    // Use the existing APPLICANT_STATUS_COLOR from FormValidation service
    const statusColorMap = {
      'APPLIED': { background: '#d9eefb', color: '#1d6fa7' },
      'JOB-APPLIED': { background: '#d9eefb', color: '#1d6fa7' },
      'SHORTLISTED': { background: '#d9eefb', color: '#1d6fa7' },
      'CANDIDATE-SHORTLISTED': { background: '#d9eefb', color: '#1d6fa7' },
      'INTERVIEW SCHEDULED': { background: '#d9eefb', color: '#1d6fa7' },
      'INTERVIEW-SCHEDULED': { background: '#d9eefb', color: '#1d6fa7' },
      'INTERVIEW-ACCEPTED': { background: '#d9eefb', color: '#1d6fa7' },
      'SELECTED': { background: '#C8E6C9', color: '#2E7D32' },
      'CANDIDATE-SELECTED': { background: '#C8E6C9', color: '#2E7D32' },
      'OFFERED': { background: '#B2DFDB', color: '#00695C' },
      'OFFER-ACCEPTED': { background: '#B2DFDB', color: '#00695C' },
      'ONBOARDED': { background: '#A5D6A7', color: '#1B5E20' },
      'PRE-ONBOARDED': { background: '#A5D6A7', color: '#1B5E20' },
      'PREONBOARDED': { background: '#A5D6A7', color: '#1B5E20' },
      'REJECTED': { background: '#ffe5e5', color: '#d40000' },
      'INTERVIEW REJECTED': { background: '#ffe5e5', color: '#d40000' },
      'INTERVIEW-REJECTED': { background: '#ffe5e5', color: '#d40000' },
      'OFFER DECLINED': { background: '#ffe5e5', color: '#d40000' },
      'OFFER-DECLINED': { background: '#ffe5e5', color: '#d40000' },
      'OFFER WITHDRAWN': { background: '#ffe0e0', color: '#a00100' },
      'OFFER-WITHDRAWN': { background: '#ffe0e0', color: '#a00100' },
      'INITIATED': { background: '#e0f5f1', color: '#2d7a6c' },
      'ACCEPTED': { background: '#e0f5f1', color: '#2d7a6c' }
    };

    const style = statusColorMap[normalizedStatus] || { background: '#d9eefb', color: '#1d6fa7' };
    return style;
  }

  // Get stage label
  getStageLabel(status: string): string {
    if (!status) return 'Applied';
    return status.split('_').join(' ').toLowerCase().replace(/\b\w/g, l => l.toUpperCase());
  }

  // Check if status is excluded from dropdown
  isExcludedStatus(status: string): boolean {
    if (this.filterApplicantData &&
        this.filterApplicantData.JOB_APPLICATION_BLOCKING_ACTIONS &&
        this.filterApplicantData.JOB_APPLICATION_BLOCKING_ACTIONS.listItems) {
      const find = this.filterApplicantData.JOB_APPLICATION_BLOCKING_ACTIONS.listItems.find(x => x.itemId === status);
      return find ? true : false;
    }
    // Fallback to hardcoded excluded statuses
    const excludedStatuses = ['REJECTED', 'OFFER DECLINED', 'OFFER WITHDRAWN', 'INTERVIEW REJECTED'];
    return excludedStatuses.includes(status);
  }

  // Filter available status options based on current status
  filterApplicant(data: any, nextAllowedStatuses?: string[]): Array<any> {
    // Backend role guard — empty array means view-only.
    if (nextAllowedStatuses && Array.isArray(nextAllowedStatuses) && nextAllowedStatuses.length === 0) {
      return [];
    }
    if (this.filterApplicantData &&
        this.filterApplicantData.JOB_APPLICATION_BUYER_ACTIONS &&
        this.filterApplicantData.JOB_APPLICATION_BUYER_ACTIONS.listItems) {
      const arrs: Array<any> = [...this.filterApplicantData.JOB_APPLICATION_BUYER_ACTIONS.listItems];

      // Backend's nextAllowedStatuses is the authoritative state machine
      // (CandidateService.DIRECT_APPLY_OWNER_NEXT / firstUpstreamAllowed). Use it
      // directly so the dropdown shows every status the backend will accept —
      // including INTERVIEW-REJECTED at INTERVIEW-ACCEPTED. Skips the legacy
      // order/wait-flow logic below which would otherwise drop valid options.
      console.log('[filterApplicant-DEBUG job-applicants] currentStatus:', data,
          'nextAllowedStatuses:', nextAllowedStatuses,
          'arrs.itemIds:', arrs.map((x: any) => x.itemId));
      if (nextAllowedStatuses && Array.isArray(nextAllowedStatuses) && nextAllowedStatuses.length > 0) {
        const result = arrs.filter((_x: any) => nextAllowedStatuses.includes(_x.itemId));
        console.log('[filterApplicant-DEBUG job-applicants] BACKEND-DRIVEN result:', result.map((x: any) => x.itemId));
        return result;
      }
      console.log('[filterApplicant-DEBUG job-applicants] FALLBACK to legacy order-based logic — nextAllowedStatuses is empty/missing');

      const currentItem = arrs.find(_x => _x.itemId === data);
      const order = currentItem?.order;
      const lastValue: Array<any> = [];
      let isWait = false;

      const finalData: Array<any> = arrs.reduce((acc: Array<any>, current, _index, arr) => {
        const isAllWait = arr.some(pp => pp.wait === true);
        const find = acc.find(_d => _d.itemId === current.itemId);
        const next = arr.indexOf(current);
        const offer = arr.filter(o => (o.order === undefined || o.order === null));

        if (find === undefined) {
          const nextData = arr[next + 1];

          if (nextData && current.item != null && data === current.itemId) {
            if ((nextData.item === undefined || nextData.item === null)) {
              isWait = true;
              return acc;
            }
            else if (nextData.item != undefined || nextData.item != null) {
              isWait = false;
              return acc;
            }
          }

          if (current && current.item != undefined && current.order != undefined) {
            acc.push(current);
          }
          else if (!lastValue.includes(offer) && (current.order === undefined || current.order === null)) {
            lastValue.push(...offer);
          }

          if (isWait) {
            acc = [];
            if (!acc.includes(offer)) {
              acc.push(...offer);
            }
          }
        }

        return acc;
      }, []);

      let final = finalData.filter(_x => _x.order > order);
      if (!isWait) {
        final.push(...lastValue);
      }

      // Role-based intersection: keep only statuses the backend says the viewer may set.
      let roleFiltered: Array<any> | null = null;
      if (nextAllowedStatuses && Array.isArray(nextAllowedStatuses) && nextAllowedStatuses.length > 0) {
        final = final.filter(_x => nextAllowedStatuses.includes(_x.itemId));
        roleFiltered = finalData.filter((_x: any) => nextAllowedStatuses.includes(_x.itemId));
      }

      // Once a candidate has reached the offer stage, "Withdraw Offer" must
      // remain available even if backend role guards (or order-based filtering)
      // would otherwise drop it. Reinstate it for OFFERED and any post-offer stage.
      const offerOrAbove = ['OFFERED', 'OFFER-ACCEPTED', 'PRE-ONBOARDED', 'PREONBOARDED'];
      if (offerOrAbove.includes(data)) {
        const withdrawItem = arrs.find((x: any) => x.itemId === 'OFFER-WITHDRAWN')
          || { itemId: 'OFFER-WITHDRAWN', item: 'Withdraw Offer', value: 'Withdraw Offer' };
        if (!final.some((x: any) => x.itemId === 'OFFER-WITHDRAWN')) {
          final.push(withdrawItem);
        }
        if (roleFiltered && !roleFiltered.some((x: any) => x.itemId === 'OFFER-WITHDRAWN')) {
          roleFiltered.push(withdrawItem);
        }
        if (!finalData.some((x: any) => x.itemId === 'OFFER-WITHDRAWN')) {
          finalData.push(withdrawItem);
        }
      }

      if (roleFiltered) {
        return isWait ? roleFiltered : final;
      }

      return isWait ? finalData : final;
    } else {
      // Return a default set of statuses if filterApplicantData is not available
      return [
        { itemId: 'SHORTLISTED', item: 'Shortlisted', value: 'Shortlisted' },
        { itemId: 'INTERVIEW SCHEDULED', item: 'Interview Scheduled', value: 'Interview Scheduled' },
        { itemId: 'SELECTED', item: 'Selected', value: 'Selected' },
        { itemId: 'OFFERED', item: 'Offered', value: 'Offered' },
        { itemId: 'ONBOARDED', item: 'Onboarded', value: 'Onboarded' },
        { itemId: 'REJECTED', item: 'Rejected', value: 'Rejected' }
      ];
    }
  }

  // Update candidate status
  updateStatus(statusData: any, candidate: any) {
    const status = statusData.itemId || statusData;
    this.updatestatus(status, candidate, null);
    // candidate.currentStatus = status;
    // this.calculateStageCounts();
  }

  // Timeline helpers using candidate's timeline data from API
  isStepCompleted(step: string, candidate: any): boolean {
    // Use timeline data if available
    if (candidate.timelineEvents && candidate.timelineEvents.length > 0) {
      return this.checkStepInTimeline(step, candidate.timelineEvents);
    }

    // Fallback: check if date exists for this step
    if (candidate.timelineDates && candidate.timelineDates[step]) {
      return true;
    }

    // Final fallback to status-based logic
    return this.isStepCompletedByStatus(step, candidate);
  }

  isCurrentStep(step: string, candidate: any): boolean {
    // Use timeline data if available
    if (candidate.timelineEvents && candidate.timelineEvents.length > 0) {
      return this.checkCurrentStepInTimeline(step, candidate.timelineEvents);
    }

    // Fallback to status-based logic
    return this.isCurrentStepByStatus(step, candidate);
  }

  // Check if step exists in timeline events (step is completed)
  checkStepInTimeline(step: string, timelineEvents: any[]): boolean {
    const stepMappings = {
      'APPLIED': ['JOB-APPLIED', 'APPLIED'],
      'SHORTLISTED': ['CANDIDATE-SHORTLISTED', 'SHORTLISTED'],
      'INTERVIEW': ['INTERVIEW-SCHEDULED', 'INTERVIEW-ACCEPTED', 'INTERVIEW SCHEDULED', 'INTERVIEW-REJECTED', 'L1-INTERVIEW', 'L2-INTERVIEW', 'L3-INTERVIEW'],
      'SELECTED': ['CANDIDATE-SELECTED', 'SELECTED'],
      'OFFERED': ['OFFERED', 'OFFER-ACCEPTED', 'OFFER-DECLINED', 'OFFER-WITHDRAWN'],
      'ONBOARDED': ['ONBOARDED', 'PREONBOARDED']
    };

    const stepStatuses = stepMappings[step] || [step];
    return timelineEvents.some(event =>
      stepStatuses.some(status => event.activityType === status)
    );
  }

  // Check if step is the current/latest step in timeline
  checkCurrentStepInTimeline(step: string, timelineEvents: any[]): boolean {
    if (timelineEvents.length === 0) return false;

    // Sort events by date, most recent first
    const sortedEvents = [...timelineEvents].sort((a, b) =>
      new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime()
    );

    const latestEvent = sortedEvents[0];

    const stepMappings = {
      'APPLIED': ['JOB-APPLIED', 'APPLIED'],
      'SHORTLISTED': ['CANDIDATE-SHORTLISTED', 'SHORTLISTED'],
      'INTERVIEW': ['INTERVIEW-SCHEDULED', 'INTERVIEW-ACCEPTED', 'INTERVIEW SCHEDULED', 'INTERVIEW-REJECTED', 'L1-INTERVIEW', 'L2-INTERVIEW', 'L3-INTERVIEW'],
      'SELECTED': ['CANDIDATE-SELECTED', 'SELECTED'],
      'OFFERED': ['OFFERED', 'OFFER-ACCEPTED', 'OFFER-DECLINED', 'OFFER-WITHDRAWN'],
      'ONBOARDED': ['ONBOARDED', 'PREONBOARDED']
    };

    const stepStatuses = stepMappings[step] || [step];
    return stepStatuses.some(status => latestEvent.activityType === status);
  }

  // Fallback: Status-based logic when timeline data not available
  isStepCompletedByStatus(step: string, candidate: any): boolean {
    const status = candidate.currentStatus?.toUpperCase() || 'APPLIED';
    const steps = ['APPLIED', 'SHORTLISTED', 'INTERVIEW', 'SELECTED', 'OFFERED', 'ONBOARDED'];

    const statusMap = {
      'JOB-APPLIED': 'APPLIED',
      'CANDIDATE-SHORTLISTED': 'SHORTLISTED',
      'INTERVIEW SCHEDULED': 'INTERVIEW',
      'INTERVIEW-SCHEDULED': 'INTERVIEW',
      'INTERVIEW-ACCEPTED': 'INTERVIEW',
      'INTERVIEW-REJECTED': 'INTERVIEW',
      'CANDIDATE-SELECTED': 'SELECTED',
      'OFFER-ACCEPTED': 'OFFERED',
      'OFFER-DECLINED': 'OFFERED',
      'OFFER-WITHDRAWN': 'OFFERED',
      'PREONBOARDED': 'ONBOARDED'
    };

    const currentStep = statusMap[status] || status;
    const stepIndex = steps.indexOf(step);
    const currentIndex = steps.indexOf(currentStep);

    return stepIndex <= currentIndex && currentIndex >= 0;
  }

  isCurrentStepByStatus(step: string, candidate: any): boolean {
    const status = candidate.currentStatus?.toUpperCase() || 'APPLIED';

    const statusMap = {
      'JOB-APPLIED': 'APPLIED',
      'CANDIDATE-SHORTLISTED': 'SHORTLISTED',
      'INTERVIEW SCHEDULED': 'INTERVIEW',
      'INTERVIEW-SCHEDULED': 'INTERVIEW',
      'INTERVIEW-ACCEPTED': 'INTERVIEW',
      'INTERVIEW-REJECTED': 'INTERVIEW',
      'CANDIDATE-SELECTED': 'SELECTED',
      'OFFER-ACCEPTED': 'OFFERED',
      'OFFER-DECLINED': 'OFFERED',
      'OFFER-WITHDRAWN': 'OFFERED',
      'PREONBOARDED': 'ONBOARDED'
    };

    const currentStep = statusMap[status] || status;
    return step === currentStep;
  }

  // Toggle skills expansion
  toggleSkills(candidate: any) {
    candidate.showAllSkills = !candidate.showAllSkills;
  }

  // Action handlers

  // Intentional no-op — the child `app-candidate-card-table-view` owns
  // the resume-download flow end-to-end (plan-check via
  // ACTIVE_INTERACTIONS, then registered blob download via
  // `candidates/resumeDownload/...`). The previous body opened
  // `this.url + fileId` directly, bypassing plan-gating entirely. See
  // candidate-card-table-view.component.ts:416-466 for the correct
  // flow. Leave body empty — child handles everything.
  downloadResume(candidate: any): void {
    // No-op on purpose. See comment above.
  }

  

  shareProfile(candidate: any) {
    // Implement share logic
  }

  scheduleInterview(candidate: any) {
    // Implement interview scheduling
  }

  addNotes(candidate: any) {
    // Implement notes functionality
  }

  // ── Invite-to-apply flow (V3 envelope icon on the applicant row) ──
  // Opens the same `<app-new-job>`-in-modal flow that talent-pool and
  // suggested-candidates-ai-list use, so the recruiter can post an
  // applicant to one of their other open jobs. Behaviour mirrors
  // `talent-pool.component.ts:556` and `suggested-candidates-ai-list
  // .component.ts:402` exactly.
  @ViewChild('jobsupplytemplate') jobSupplyTemplate: TemplateRef<any>;
  isClicked: boolean = false;
  candidateData: any;
  focus: string;
  candidateSupplyRef: BsModalRef;

  invite(values: any) {
    if (this.isClicked) return;
    this.util.startLoader();
    this.isClicked = true;
    this.candidateData = values;
    this.focus = 'candidate';
    this.proceedToInvite(values, this.jobSupplyTemplate);
    setTimeout(() => { this.isClicked = false; }, 5000);
  }

  async proceedToInvite(values, jobsupplytemplate) {
    this.util.startLoader();
    const userData = await this.planService.UPDATE_USERDETAILS('ACTIVE_INTERACTIONS');
    let { membershipType } = userData;
    if (userData.isExpired) {
      this.util.stopLoader();
      let availablePoints = null;
      let actualPoints = null;
      let utilizedPoints = null;
      let promotional = null;
      userData.userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
        if (ele.benefitKey == 'ACTIVE_INTERACTIONS') {
          this.util.stopLoader();
          availablePoints = ele.available;
          actualPoints = ele.actual;
          utilizedPoints = ele.utilized;
          promotional = ele.promotional;
        }
      });
      let popupType: 'PAY' | 'LIMIT' | 'UPGRADE' = 'PAY';
      if (['Starter', 'Growth', 'ScaleX'].includes(membershipType)) {
        popupType = 'LIMIT';
      }
      this.planService.expiredPopup('ACTIVE_INTERACTIONS', popupType, null, null, null, null, availablePoints, actualPoints, utilizedPoints, promotional);
      return;
    }
    values.userId = localStorage.getItem('userId');
    values.candidatefilter = true;
    values.getResume = false;
    values.userType = values.user ? values.user.userType : null;
    const config: ModalOptions = { class: 'modal-lg', backdrop: 'static', keyboard: false };
    this.candidateSupplyRef = this.bsModalService.show(jobsupplytemplate, config);
    this.util.stopLoader();
  }

  getApplicantsCounts(jobDetails:any) {
    // No-op kept for backward compatibility with existing call sites.
    // Counts are now read directly from the /candidates/findAppliedCandidates response
    // (in processResponse) — derived from the same post-filter list, so the count always
    // matches the visible rows. The separate /candidates/getApplicantsCounts call is
    // no longer needed.
  }

  selectedStage: string = 'ALL'; // Initialize with 'ALL' to match UI default

  /* COMMENTED OUT: Timeline properties moved to candidate-card component
  // Timeline properties (from candidate-card component)
  timelineIsLoading = false;
  jeas: any = [];
  mergedTimelineData: any[] = [];
  filterStatusData: Array<any>;
  jobApplicationListValues: any[] = [];
  jobApplicationFutureListValues: any[] = [];
  blockingListValues: any[] = [];
  displayingdata: any;
  payload: any = {};
  timelineCache: Map<string, any> = new Map();
  activityEnded: boolean = false;
  */

  selectStage(stage: string) {
    // Prevent rapid-click race conditions
    if (this.loadAPIcall) {
      console.log('API call already in progress, ignoring click');
      return;
    }

    // Validate that filter data is loaded
    if (!this.tempStatusList || this.tempStatusList.length === 0) {
      console.warn('Filter data not loaded yet, cannot select stage');
      this.applicantsFoundStatus = "Loading filter data, please wait...";
      return;
    }

    // Reset state for new stage selection
    this.selectedStage = stage;
    this.pageNumber = 0;
    this.response = [];
    this.stopscrollFlag = false;
    this.responseReceived = false;

    // Reset scroll position to top when stage is changed
    this.resetScrollPosition();

    // Update filter based on selected stage
    const filterUpdateSuccess = this.updateFilterForStage(stage);

    // Only proceed if filter update was successful
    if (!filterUpdateSuccess) {
      console.error('Failed to update filter for stage:', stage);
      this.applicantsFoundStatus = "Unable to load candidates for this stage.";
      this.stopscrollFlag = true;
      return;
    }

    // Get the comma-separated status string for API call
    const statusString = this.jobApplicantStatusList.map(c => c.itemId).toString();

    if (!statusString || statusString.trim() === '') {
      console.error('No valid statuses found for stage:', stage);
      this.applicantsFoundStatus = "No applicants found for this stage.";
      this.stopscrollFlag = true;
      return;
    }

    this.response = [];

    // Make the API call
    this.getCandidateList(statusString);
    this.getApplicantsCounts(this.jobDetails);
  }

  // Document Management Properties
  showDocumentSection: boolean = false;

   typeOfDocuments = [
      {name: 'Resume', mandatory: false, isUploaded: true, 
        documents:[
          // {name: 'New Resume',lastUpdated: '28/09/2025',validFrom : '', expiry:'', status: 'Verified', attachment:''},
        ],
        headers : []
      },
      {name: 'Drivers License', mandatory: false, isUploaded: true, 
        documents:[
          // {name: 'License',lastUpdated: '28/09/2025',validFrom : '25/08/2003', expiry:'16/08/2023', status: 'Expired', attachment:''},
          // {name: 'License',lastUpdated: '28/09/2025',validFrom : '13/04/2024', expiry:'19/12/2035', status: 'Pending Verification', attachment:''},
        ]
      },
      {name: 'Employment Authorization Document', mandatory: false, isUploaded: false,documents:[]},
      {name: 'Passport', mandatory: false, isUploaded: false,documents:[]},
      {name: 'Visa', mandatory: false, isUploaded: false,documents:[]},
      {name: 'I-94', mandatory: false, isUploaded: false,documents:[]},
      {name: 'Background Check Certification', mandatory: false, isUploaded: false,documents:[]},
      {name: 'Background Verification', mandatory: false, isUploaded: false,documents:[]},
      {name: 'Drug Screening', mandatory: false, isUploaded: false,documents:[]}
    ];
    
    selectedCandidateForDocument:any;
    openDocuments(cand:any) {
      // Swal.fire('candidate id ', cand.candidateId,'info');
      // Clear the previous candidate's documents BEFORE the slider renders.
      // `typeOfDocuments` is a single shared array reused for every candidate,
      // and getSavedRequiredDocuments() repopulates it in place asynchronously
      // (and bails via `if (!config) return` when the candidate has no saved
      // config). Without this reset the slider would show the last candidate's
      // documents during the fetch, and keep showing them entirely when the new
      // candidate has none — i.e. stale data that doesn't belong to this one.
      // this.resetTypeOfDocuments();
      this.showDocumentSection = true;
      this.selectedCandidateForDocument = cand;
      this.getSavedRequiredDocuments(cand.candidateId);
    }

    /** Blank out the shared document buckets + header counts so the slider
     *  starts clean for whichever candidate is opened next. */
    resetTypeOfDocuments() {
      for (let doc of this.typeOfDocuments) {
        doc.mandatory = false;
        doc.documents = [];
      }
      this.totalMandatoryDocuments = 0;
      this.allVerified = false;
    }
  
    closeDocuments() {
      this.showDocumentSection = false;
      this.selectedCandidateForDocument = null;
    }
  
    refreshDocumentData() {
      // Call existing method to fetch fresh data
      if(this.selectedCandidateForDocument){
        this.getSavedRequiredDocuments(this.selectedCandidateForDocument.candidateId);
      }
    }
  
    documentsRequired ={
      "jobId":'',
      "candidateId": '',
      "resumeMandatory": '',
      "driversLicenseMandatory": '',
      "employmentAuthorizationMandatory": '',
      "passportMandatory": '',
      "visaMandatory": '',
      "i94Mandatory": '',
      "backgroundCheckstatusMandatory": '',
      "backgroundCheckCertificateMandatory": '',
      "drugScreenMandatory": '',
      "conversationKey":"SENDER"
    }
  
    saveDocuments(value:any) {
      console.log('list of documents  ;:: ', value);
      this.documentsRequired.jobId = this.jobDetails.jobId;
      this.documentsRequired.candidateId = this.selectedCandidateForDocument.candidateId;
      
      this.documentsRequired.resumeMandatory = value.find(e => e.name === 'Resume')?.mandatory ?? false;
      this.documentsRequired.driversLicenseMandatory = value.find(e => e.name === 'Drivers License')?.mandatory ?? false;
      this.documentsRequired.employmentAuthorizationMandatory = value.find(e => e.name === 'Employment Authorization Document')?.mandatory ?? false;
      this.documentsRequired.passportMandatory = value.find(e => e.name === 'Passport')?.mandatory ?? false;
      this.documentsRequired.visaMandatory = value.find(e => e.name === 'Visa')?.mandatory ?? false;
      this.documentsRequired.i94Mandatory = value.find(e => e.name === 'I-94')?.mandatory ?? false;
      this.documentsRequired.backgroundCheckstatusMandatory = value.find(e => e.name === 'Background Verification')?.mandatory ?? false;
      this.documentsRequired.backgroundCheckCertificateMandatory = value.find(e => e.name === 'Background Check Certification')?.mandatory ?? false;
      this.documentsRequired.drugScreenMandatory = value.find(e => e.name === 'Drug Screening')?.mandatory ?? false;
  
      console.log('documents required :: ', this.documentsRequired);
  
      this.util.startLoader();
      this.apiService.create('jobs/requestMandatoryDocuments', this.documentsRequired)
      .pipe(
        finalize(() => this.util.stopLoader()) // always stop loader
      )
      .subscribe({
        next: (res: any) => {
          console.log('res ', res);
          if (res.code === '00000') {
            this.showDocumentSection = false;
            Swal.fire({
              title: 'Required documents updated successfully',
              icon: 'success',
              showConfirmButton: false,
              timer: 2000   // auto close after 2 seconds
            });
            this.getSavedRequiredDocuments(value.candidateId);
          } else {
            Swal.fire('', res?.message || 'Something went wrong', 'error');
          }
        },
        error: (err) => {
          console.error(err);
          Swal.fire('Something went wrong', '', 'error');
        }
      });     
    }
  
    totalMandatoryDocuments:any;
    allVerified:any;
    getSavedRequiredDocuments(candId:any) {
      let payload = {
        jobId: this.jobDetails.jobId,
        candidateId: candId
      };
  
      this.util.startLoader();
      this.apiService.create('jobs/getContractDocumentDetails', payload)
        .pipe(finalize(() => this.util.stopLoader()))
        .subscribe({
          next: (res: any) => {
            console.log('details , ', res);
            const config = res.data?.existingConfig;
  
            if (!config) return;
  
            // Map API response to typeOfDocuments
            for (let doc of this.typeOfDocuments) {
              switch (doc.name) {
                case 'Resume':
                  doc.mandatory = config.resumeMandatory;
                  doc.documents = config?.resumeDocuments || [];
                  break;
                case 'Drivers License':
                  doc.mandatory = config.driversLicenseMandatory;
                  doc.documents = config?.driversLicenseDocuments || [];
                  break;
                case 'Employment Authorization Document':
                  doc.mandatory = config.employmentAuthorizationMandatory;
                  doc.documents = config?.employmentAuthorizationDocuments || [];
                  break;
                case 'Passport':
                  doc.mandatory = config.passportMandatory;
                  doc.documents = config?.passportDocuments || [];
                  break;
                case 'Visa':
                  doc.mandatory = config.visaMandatory;
                  doc.documents = config?.visaDocuments || [];
                  break;
                case 'I-94':
                  doc.mandatory = config.i94Mandatory;
                  doc.documents = config?.i94Documents || [];
                  break;
                case 'Background Verification':
                  doc.mandatory = config.backgroundCheckstatusMandatory;
                  doc.documents = config?.backgroundCheckDocuments || [];
                  break;
                case 'Background Check Certification':
                  doc.mandatory = config.backgroundCheckCertificateMandatory;
                  doc.documents = config?.backgroundCheckCertificationDocuments || [];
                  break;
                case 'Drug Screening':
                  doc.mandatory = config.drugScreenMandatory;
                  doc.documents = config?.drugScreenDocuments || [];
                  break;
              }
            }
            // ✅ Count how many documents are mandatory
            // this.totalMandatoryDocuments = this.typeOfDocuments.filter(d => d.mandatory).length;
            const allVerified = res?.data?.documentProgress?.allMandatoryVerified;
            this.totalMandatoryDocuments = allVerified ? res?.data?.documentProgress?.totalVerifiedCount  ?? 0
                                                        : res?.data?.documentProgress?.headerCount ?? 0;
  
            this.allVerified = allVerified;
  
            console.log('Updated typeOfDocuments :: ', this.typeOfDocuments);
          },
          error: (err: any) => {
            console.error('Error fetching document details', err);
          }
        });
    }

  updateFilterForStage(stage: string): boolean {
    // Reset filter data
    this.removedData = {};
    this.jobApplicantStatusList = [];

    // Validate tempStatusList is available
    if (!this.tempStatusList || this.tempStatusList.length === 0) {
      console.error('updateFilterForStage: tempStatusList is not available');
      return false;
    }

    // Map stage to status values.
    // The "In Process" bucket includes L1/L2/L3 interview rounds — must stay in sync
    // with the inProcess buckets in CandidateService.findAppliedCandidates count pass
    // (the visibility-aware count and the fallback path).
    const stageStatusMap = {
      'ALL': null, // Special case: return all statuses
      'JOB-APPLIED': ['JOB-APPLIED'],
      'CANDIDATE-SHORTLISTED,INTERVIEW-SCHEDULED,INTERVIEW-ACCEPTED,L1-INTERVIEW,L2-INTERVIEW,L3-INTERVIEW':
          ['CANDIDATE-SHORTLISTED', 'INTERVIEW-SCHEDULED', 'INTERVIEW-ACCEPTED', 'L1-INTERVIEW', 'L2-INTERVIEW', 'L3-INTERVIEW'],
      'CANDIDATE-SELECTED': ['CANDIDATE-SELECTED'],
      'OFFERED': ['OFFERED'],
      'ONBOARDED': ['ONBOARDED']
    };

    // Get status list for the selected stage
    let statusList: string[];

    if (stage === 'ALL') {
      // For 'ALL' stage, use all available statuses from tempStatusList
      statusList = this.tempStatusList.map(item => item.itemId);
      this.jobApplicantStatusList = [...this.tempStatusList];
    } else if (stageStatusMap[stage]) {
      // Use predefined mapping
      statusList = stageStatusMap[stage];
      this.jobApplicantStatusList = this.tempStatusList.filter(item =>
        statusList.includes(item.itemId)
      );
    } else {
      // Fallback: split by comma for custom stage strings
      statusList = stage.split(',').map(s => s.trim()).filter(s => s.length > 0);

      if (statusList.length === 0) {
        console.error('updateFilterForStage: Invalid stage parameter:', stage);
        return false;
      }

      this.jobApplicantStatusList = this.tempStatusList.filter(item =>
        statusList.includes(item.itemId)
      );
    }

    // Validate that we have at least one status to filter by
    if (!this.jobApplicantStatusList || this.jobApplicantStatusList.length === 0) {
      console.warn('updateFilterForStage: No matching statuses found for stage:', stage);
      console.warn('Available statuses:', this.tempStatusList.map(s => s.itemId));
      console.warn('Requested statuses:', statusList);

      // For 'ALL' stage, this should never happen, but handle gracefully
      if (stage === 'ALL') {
        console.error('updateFilterForStage: Critical error - ALL stage has no statuses');
        return false;
      }

      // For other stages, this might be valid if no candidates match
      return true; // Return true but with empty list (will show "no candidates" message)
    }

    // Update removedData object for filter component synchronization
    this.jobApplicantStatusList.forEach(element => {
      this.removedData[element.itemId] = true;
    });

    // Update localStorage for filter component persistence
    localStorage.setItem('jobApplicantStatus', JSON.stringify(statusList));

    console.log('updateFilterForStage: Success', {
      stage,
      statusList,
      matchedCount: this.jobApplicantStatusList.length
    });

    return true;
  }

  async route(values: any) {


    if (values.createdBy != this.userId && !values.isViewed) {

      this.updateCandidateView(values);

    }
    else {
      this.router.navigate(["newcandidates"], { queryParams: { candidateId: values.candidateId, tabName: 'profileSummary', From: this.From, jobId: this.jobDetails?.jobId } });
    }
  }

  updateCandidateView(values: any) {
    this.util.startLoader();
    this.candidateService.updateCandidateViewed(values).subscribe((res) => {
      this.util.stopLoader();
      if (res.code === "00000") {
        this.router.navigate(["newcandidates"], { queryParams: { candidateId: values.candidateId, tabName: 'profileSummary', From: this.From, jobId: this.jobDetails?.jobId } });
      }
    },
      (err) => {
        this.util.stopLoader();
      });
  }

  reasons: any[] = [];
  candidateScore:any;
  private retryAttempt: number = 0;

  showDetails(item:any, modal:any){
    console.log('item: ', item);
    let payload = {
      sourceEntityId : this.jobDetails.jobId,
      targetEntityId : item.candidateId,
      type : 'JOB',
      groupType : 'APPLICANT_JOB'
    }
    // Don't use util.startLoader() - it blocks entire app during AI processing
    this.reasons = [];
    this.candidateScore = null;
    this.retryAttempt = 0;

    // Use default retry settings: 3 retries with 25s delay = ~75s total
    this.apiService.fetchRankingDetailsWithRetry(payload).subscribe({
      next: (res) => {
        if(res.code == '00000'){
          // Handle both old format (ranking) and new format (rankings array)
          let ranking = null;

          if (res.data.ranking) {
            // Old format: single ranking object
            ranking = res.data.ranking;
          } else if (res.data.rankings && res.data.rankings.length > 0) {
            // New format: rankings array
            const firstRanking = res.data.rankings[0];
            if (firstRanking.targetEntities && firstRanking.targetEntities.length > 0) {
              const targetEntity = firstRanking.targetEntities[0];
              // Merge ranking data with targetEntity data
              ranking = {
                ...firstRanking,
                targetEntityId: targetEntity.targetEntityId,
                score: targetEntity.score,
                reason: targetEntity.reason || firstRanking.reason,
                strengths: targetEntity.strengths || firstRanking.strengths || [],
                weaknesses: targetEntity.weaknesses || firstRanking.weaknesses || [],
                updatedOn: targetEntity.updatedOn || firstRanking.updatedOn
              };
            }
          }

          if(ranking){
            // Build reasons array from the ranking object
            this.reasons = [{
              targetEntityId: ranking.targetEntityId,
              score: ranking.score,
              reason: ranking.reason,
              strengths: ranking.strengths || [],
              weaknesses: ranking.weaknesses || [],
              updatedOn: ranking.updatedOn
            }];

            this.candidateScore = ranking.score + '%';
            this.openModal(modal);
          }else {
            Swal.fire('No ranking details available','','info');
          }
        }else {
          Swal.fire('Something went wrong','','error');
        }
      },
      error: (err) => {

        // Handle processing timeout
        if (err.timeout && err.isProcessing) {
          Swal.fire({
            title: 'Analysis In Progress',
            text: err.message || 'The AI analysis is taking longer than expected. Please try again in a moment.',
            icon: 'warning',
            confirmButtonText: 'OK'
          });
        } else if (err.isProcessing) {
          // Retry in progress - show loading message
          this.retryAttempt++;
          Swal.fire({
            title: 'Analyzing Match...',
            html: `AI is analyzing candidate compatibility.<br><small>Attempt ${this.retryAttempt}/3</small>`,
            icon: 'info',
            timer: 2500,
            timerProgressBar: true,
            showConfirmButton: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
        } else {
          // Other errors
          Swal.fire('Something went wrong','','error');
        }
      }
    });
  }

  openModal(modalName: any){
    try {
      this.modalService.open(modalName, {size: 'md', centered: true}).result.then((result) => {
        console.log('Modal closed with result:', result);
      }, (reason) => {
        console.log('Modal dismissed with reason:', reason);
      });
    } catch (error) {
      console.error('Error opening modal:', error);
      Swal.fire('Error', 'Failed to open modal', 'error');
    }
  }

  closeModal(){
    this.modalService.dismissAll();
  }

  async openMessagecheckInteraction(seletedItem, connectionTemplate?: TemplateRef<any>) {
      // Universal first-interaction: exist-first — skip the ACTIVE_INTERACTIONS gate
      // when this candidate's interaction was already consumed (existing chat / prior
      // invite / resume-request — backend `alreadyConsumed`). Fails safe to gating.
      if (await this.planService.isInteractionAlreadyConsumed(seletedItem?.candidateId, 'CANDIDATE')) {
        this.chatuser(seletedItem);
        return;
      }
      try {
        this.util.startLoader();
        const userData = await this.planService.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
        let { userDetail, isExpired, membershipType } = userData;
        let availablePoints = null;
        let actualPoints = null;
        let utilizedPoints = null;
        let promotional = null;
        if (userDetail && userDetail.userPlanAndBenefits && userDetail.userPlanAndBenefits.benefitsUsages) {
          userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
            if (ele.benefitKey == 'ACTIVE_INTERACTIONS') {
              availablePoints = ele.available;
              actualPoints = ele.actual;
              utilizedPoints = ele.utilized;
              promotional = ele.promotional;
            }
          });
        } else {
          this.util.startLoader();
          this.chatuser(seletedItem);
  
          return;
        }
  
        if (isExpired) {
          let popupType: "PAY" | "LIMIT" | "UPGRADE" = "PAY";
  
          if (['Starter','Growth','ScaleX'].includes(membershipType)) {
            popupType = "LIMIT";
          }
  
          this.planService.expiredPopup("ACTIVE_INTERACTIONS", popupType, null, null, null,null, availablePoints, actualPoints, utilizedPoints, promotional);
  
        } else {
          this.util.startLoader();
          this.chatuser(seletedItem);
  
        }
      } catch (error) {
      } finally {
        setTimeout(() => {
          this.util.stopLoader();
        },1500);
      }
  
    }

    chatuser(seletedItem: any, connectionModal?: TemplateRef<any>) {

    // this.candidateData = seletedItem;
    // this.focus = 'candidate';
    if (seletedItem.createdBy == this.userId) {
      this.openMessage(seletedItem)
    }
    this.checkConnectionStatus(seletedItem)
      .subscribe(response => {
        if (seletedItem.isFeatured != undefined && seletedItem.isFeatured == true) {
          this.openMessage(seletedItem)
        } else if (seletedItem.isFeatured == false || seletedItem.isFeatured == undefined && seletedItem.createdBy != this.userId) {
          //if (response.data.connectionStatus === 'CONNECTED') {
            this.openMessage(seletedItem);
          //} else if (response.data.connectionStatus !== 'CONNECTED') {
           // this.openMessage(seletedItem);
            // to be used later
            // this.openConnectionTemplate(response.data.connectionStatus, seletedItem, connectionModal);
          //}
        }
      })
  }

  checkConnectionStatus(values): Observable<any> {
    const apiURL = 'user/checkConnectionStatus';
    const params = new HttpParams()
      .set('userId', this.userId)
      .set('connnectorId', values.createdBy);

    const urlWithParams = `${apiURL}?${params.toString()}`;
    return this.apiService.query(urlWithParams);
  }

  messagemodelflag:any;
  seletedChatItem:any;
  messageData:any;
  openMessage(seletedItem) {
    this.messagemodelflag = false;
    // this._socket.ngOnDestroy();
    // this._socket.connections();

    if (seletedItem.createdBy == this.userId) {
      seletedItem.owner = true;
    } else {
      seletedItem.owner = false;
    }

    setTimeout(() => {
      // if (this.userId != seletedItem.createdBy) {
      seletedItem.userId = seletedItem.createdBy;
      this.seletedChatItem = seletedItem;
      this.messageData = [];
      this.messagemodelflag = true;
      seletedItem.groupType = "CANDIDATE";
      seletedItem.messageType = "CANDIDATE";
      seletedItem.id = seletedItem.candidateId;
      this.messageData = seletedItem;
      // }
    }, 1000);
  }

  closeMessage(event) {
    this.messagemodelflag = false;
    // this._socket.ngOnDestroy();
  }

  // Helper method to set rank on candidate object for row-design view
  setRankAndShowSkills(item: any, rank: number): any {
    // Modify the item in place to avoid creating new object references
    if (item.showAllSkills === undefined) {
      item.showAllSkills = false;
    }
    item.rank = rank;
    return item;
  }

  statusUpdateTriggered(candidate:any){
    // Stage counts now ride along with the /findAppliedCandidates response
    // (processResponse:369-377). The legacy getApplicantsCounts call is a
    // no-op, so a status change has to re-fetch the list to refresh both
    // the count cards and the pipeline tabs.
    this.refreshApplicantList();
  }

  private refreshApplicantList() {
    const status = (this.jobApplicantStatusList || []).map(c => c.itemId).toString();
    if (!status) return;
    this.pageNumber = 0;
    this.response = [];
    this.stopscrollFlag = false;
    this.responseReceived = false;
    this.getCandidateList(status);
  }

}
